import { useState, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";
import { UseExpert } from "./UseExpert";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ExpertreviewImagesGrid from "./ExpertreviewImagesGrid";

function EditExpert() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { getExpertByID, updateExpert } = UseExpert();
  const [state, setState] = useState({
    productID: "",
    expertReview: "",
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      getExpertByID(location.state.id, (brandRes) => {
        setState({
          productID: brandRes && brandRes.productID,
          expertReview:
            brandRes && brandRes.expertReview ? brandRes.expertReview : "",
        });
      });
    }
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/expertreview" },
          {
            name: "ویرایش نقد و بررسی" + " (" + location.state.id + ")",
            url: "/expertreview/editexpert",
            targetID: location.state.id,
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn="span 12">
            {state.id !== "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                data={state.expertReview ? state.expertReview : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (state.productID) {
                    setState({ ...state, expertReview: data });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "500px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              تصاویر نقد و بررسی :
            </Typography>
            <ExpertreviewImagesGrid
              productId={state.productID ? state.productID : ""}
            />
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center", mb: 3 }}
            gridColumn="span 12"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                setProgress(true);
                updateExpert(state, () => {
                  navigate("/expertreview", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/expertreview", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditExpert;
